const ORIGIN = "https://vanvlimmerenfeestverhuur.nl";

// React 19 hoists <title>/<meta>/<link> rendered anywhere into <head>,
// so each page declares its own metadata — no helmet library needed.
// `title` is suffixed with the brand; pass `suffix={false}` to use it as-is.
function Seo({ title, description, path, suffix = true }) {
	return (
		<>
			<title>{suffix ? `${title} | Van Vlimmeren Feestverhuur` : title}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={ORIGIN + path} />
		</>
	);
}

export default Seo;
